"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metaAdsFetch = exports.metaAdsFetchResultSchema = exports.metaAdsFetchArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.metaAdsFetchArgsSchema = zod_1.z
    .object({
    activeStatus: zod_1.z
        .enum(['ACTIVE', 'INACTIVE', 'ALL'])
        .describe('The status of the ads to fetch. Unless specified, defaults to ACTIVE.')
        .default('ACTIVE'),
    country: zod_1.z
        .string()
        .describe('The country to search for ads. e.g. US, UK, etc. Unless specified, defaults to ALL.')
        .default('ALL'),
    maxItems: zod_1.z
        .number()
        .describe('The maximum number of ads to fetch. Unless specified, defaults to 10.'),
    emitMode: common_1.emitModeSchema,
    options: zod_1.z
        .object({
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no results. Unless specified, defaults to true.'),
    })
        .describe('Search options'),
    searchPageUrlOrName: zod_1.z
        .string()
        .describe('The Facebook page URL or company name to search for ads. If it contains facebook.com or is a URL, it will be treated as a page URL. Otherwise, it will be treated as a company name. e.g. https://www.facebook.com/google or "Google"'),
})
    .describe("Default activeStatus is ACTIVE, country is ALL, and maxItems is 10.");
exports.metaAdsFetchResultSchema = zod_1.z.array(zod_1.z.object({
    ad_archive_id: zod_1.z.string(),
    page_id: zod_1.z.string(),
    start_date: zod_1.z.number(),
    end_date: zod_1.z.number(),
    snapshot: zod_1.z.object({
        body: zod_1.z.object({ text: zod_1.z.string().nullish() }),
        branded_content: zod_1.z.any().nullish(),
        byline: zod_1.z.any().nullish(),
        caption: zod_1.z.string().nullish(),
        link_url: zod_1.z.string().nullish(),
        link_description: zod_1.z.string().nullish(),
        cards: zod_1.z.array(zod_1.z.object({
            cta_text: zod_1.z.string().nullish(),
            cta_type: zod_1.z.string().nullish(),
            link_url: zod_1.z.string().nullish(),
            link_description: zod_1.z.string().nullish(),
            image_crops: zod_1.z.array(zod_1.z.string()).default([]),
            original_image_url: zod_1.z.string().nullish(),
            resized_image_url: zod_1.z.string().nullish(),
            watermarked_resized_image_url: zod_1.z.string().nullish(),
            title: zod_1.z.string().nullish(),
            video_hd_url: zod_1.z.string().nullish(),
            video_preview_image_url: zod_1.z.string().nullish(),
            video_sd_url: zod_1.z.string().nullish(),
            watermarked_video_hd_url: zod_1.z.string().nullish(),
            watermarked_video_sd_url: zod_1.z.string().nullish(),
        })),
        images: zod_1.z.array(zod_1.z.object({
            original_image_url: zod_1.z.string().nullish(),
            resized_image_url: zod_1.z.string().nullish(),
            watermarked_resized_image_url: zod_1.z.string().nullish(),
            image_crops: zod_1.z.array(zod_1.z.string()).default([]),
        })),
        videos: zod_1.z.array(zod_1.z.object({
            video_hd_url: zod_1.z.string().nullish(),
            video_preview_image_url: zod_1.z.string().nullish(),
            video_sd_url: zod_1.z.string().nullish(),
            watermarked_video_hd_url: zod_1.z.string().nullish(),
            watermarked_video_sd_url: zod_1.z.string().nullish(),
        })),
        page_categories: zod_1.z.array(zod_1.z.string()).default([]),
        page_entity_type: zod_1.z.string().nullish(),
        page_like_count: zod_1.z.number().nullish(),
        page_profile_picture_url: zod_1.z.string().nullish(),
        page_profile_uri: zod_1.z.string().nullish(),
        title: zod_1.z.string().nullish(),
    }),
}));
exports.metaAdsFetch = (0, common_1.createEmitModeToolMetadata)({
    id: 'metaAdsFetch',
    displayName: 'Meta Ads Fetch',
    displayDescription: 'Fetch Meta (Facebook) ads using the Meta Ads Library API.',
    category: 'ads',
    color: common_1.BRAND_COLORS.META,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.META),
    icon: 'meta',
    argsSchema: exports.metaAdsFetchArgsSchema,
}, exports.metaAdsFetchResultSchema);
